var _defs, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherLiabilityEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.103,
    cy: 17.287,
    r: 1.501
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 11.766,
    cy: 24.024,
    r: 3.884
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.776 33.239v-.698a3.69 3.69 0 00-3.69-3.69h-6.64a3.69 3.69 0 00-3.69 3.69v.698"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M6.467 17.436c.22-.82-.12-1.7-.78-2.24l-2.3-1.9.8-1.61 3.79 1.28c.85.26 1.78.02 2.38-.65h.003c.81-.931 1.63-1.641 2.19-2.031 1.26-.88 2.63-1.63 5.33-2.07l-1.31 5.62 2.93 2.08 1.38 7.19 3.53-8.02-2.48-2.88 2.31-4.02c1.29.16 2.36.4 3.29.76l.003-.002 4.57-1.87-.09 5.13c1.72 1.97 2.23 4.8 2.23 4.8l3.52 1.24v5.55l-3.72 1.37s-.6 1.64-1.73 2.65c-1.15 1.02-2.59 1.67-2.59 1.67l-.64 3.42h-3.49l-.67-3h-1.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLiabilityEmployee);
export default __webpack_public_path__ + "static/media/otherLiabilityEmployee.75b2d1b767c0b23a277c801cc8da7378.svg";
export { ForwardRef as ReactComponent };